import MessageTypes from "enums/message-types";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import { Card, Grid } from "@mui/material";
import { connect } from "react-redux";
import Swal from "sweetalert2";

import { useHistory } from "react-router-dom";
import initialValues from "layouts/sub-organization/components/sub-organization-details/schemas/subOrganizatonFormInitialValues";
import validations from "layouts/sub-organization/components/sub-organization-details/schemas/subOrganizationFormValidation";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import initialForm from "layouts/sub-organization/components/sub-organization-details/schemas/subOrganizationForm";
import localizeForm from "layouts/sub-organization/components/sub-organization-details/schemas/subOrganizationLocalizeForm";
import { removeMessage } from "redux/actions/message";

import {
  startNewSubOrganizationScreen,
  saveSubOrganization,
} from "redux/actions/pages/sub-organization";
import SubOrganizationForm from "../SubOrganizationForm";

const SubOrganizationDetails = ({
  localizations,
  message,
  removeErrorMsg,
  startScreen,
  saveNewSubOrganization,
  subOrganization,
  allOrganizations,
}) => {
  const [form, setForm] = useState(initialForm);
  const history = useHistory();

  const isEditMode = subOrganization && subOrganization?.id > 0;

  useEffect(() => {
    startScreen();
  }, []);

  useEffect(() => {
    setForm(localizeForm(form, localizations));
  }, [localizations]);

  useEffect(() => {
    if (
      message &&
      message.messageContent !== undefined &&
      message.messageContent !== null &&
      message.messageContent !== ""
    ) {
      Swal.fire({
        icon: message.messageType || "error",
        title:
          message.messageType === MessageTypes.success
            ? localizations?.MESSAGE_SUCCESS
            : localizations?.MESSAGE_ERROR,
        text: message.messageContent,
        showCancelButton: false,
        confirmButtonText: localizations?.MESSAGE_GO_HOME_CONFIRM_BTN,
      }).then(() => {
        removeErrorMsg();
        history.push("/suborganization");
      });
    }
  }, [message]);

  const getInitialValues = () => {
    if (subOrganization && subOrganization?.id > 0) {
      let selectedOrganization = null;
      if (subOrganization.organizationId && Array.isArray(allOrganizations)) {
        const foundOrganization = allOrganizations.find(
          (organization) => organization.id === subOrganization.organizationId
        );
        if (foundOrganization) {
          selectedOrganization = {
            value: foundOrganization.id,
            label: foundOrganization.organizationKey,
          };
        }
      }
      return {
        subOrganizationKey: subOrganization.subOrganizationKey || "",
        country: subOrganization.country || "",
        city: subOrganization.city || "",
        district: subOrganization.district || "",
        address: subOrganization.address || "",
        phone: subOrganization.phone || "",
        email: subOrganization.email || "",
        organization: selectedOrganization,
      };
    }
    return initialValues;
  };

  const handleSubmit = (values, actions) => {
    const selectedOrganizationId = values.organization?.value ?? null;

    const formattedValues = {
      subOrganizationKey: values.subOrganizationKey ?? "",
      country: values.country ?? "",
      city: values.city ?? "",
      district: values.district ?? "",
      address: values.address ?? "",
      phone: values.phone ?? "",
      email: values.email ?? "",
    };

    if (subOrganization && subOrganization?.id > 0) {
      formattedValues.id = subOrganization.id;
    }

    const payload = {
      organizationId: selectedOrganizationId,
      subOrganization: { ...formattedValues },
    };

    saveNewSubOrganization(payload);

    actions.setSubmitting(false);
    actions.resetForm();
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={getInitialValues()}
        validationSchema={validations.validation}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form id={form.formId} autoComplete="off">
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Card sx={{ overflow: "visible" }}>
                  <SuiBox p={3}>
                    <SubOrganizationForm
                      formData={{
                        formField: form.formField,
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        setFieldTouched,
                      }}
                      allOrganizations={allOrganizations}
                      isEditMode={isEditMode}
                    />
                    <SuiBox display="flex" my={5}>
                      <SuiBox ml="auto">
                        <SuiButton
                          disabled={isSubmitting}
                          type="submit"
                          variant="contained"
                          color="dark"
                          size="small"
                        >
                          {localizations?.FORM_SAVE_BTN}
                        </SuiButton>
                      </SuiBox>
                    </SuiBox>
                  </SuiBox>
                </Card>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

SubOrganizationDetails.defaultProps = {
  localizations: null,
  message: null,
  subOrganization: null,
  allOrganizations: null,
};

SubOrganizationDetails.propTypes = {
  localizations: PropTypes.objectOf(PropTypes.any),
  message: PropTypes.objectOf(PropTypes.any),
  removeErrorMsg: PropTypes.func.isRequired,
  startScreen: PropTypes.func.isRequired,
  saveNewSubOrganization: PropTypes.func.isRequired,
  subOrganization: PropTypes.objectOf(PropTypes.any),
  allOrganizations: PropTypes.arrayOf(PropTypes.any),
};

const mapStateToProps = (state) => ({
  localizations: state.localization?.pairs,
  allOrganizations: state.data?.organizations ?? [],
});

const mapDispatchToProps = {
  removeErrorMsg: removeMessage,
  startScreen: startNewSubOrganizationScreen,
  saveNewSubOrganization: saveSubOrganization,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubOrganizationDetails);
